var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VisitList',{attrs:{"title":"همه‌ی ویزیت‌ها","editable":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }